import { render, staticRenderFns } from "./manageCate.vue?vue&type=template&id=3a59cfd0&"
import script from "./manageCate.vue?vue&type=script&lang=js&"
export * from "./manageCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports